import { BoxProps } from 'UIKit/Box/types'
import { Game, ResponsiveGameCollection } from 'config/types/game'
import { BetDetails } from 'config/types/profile'
import useComponentOnScreen from 'hooks/useComponentOnScreen'
import Column from 'layout/Components/Column'
import React, { useCallback } from 'react'
import GameService from 'services/GameService'
import { BaseResponse, HunnyRequest, LiveBetTypeEnum, Paging } from 'services/types'
import LiveWinStream from './components/LiveWinStream'

interface LiveWinProps extends BoxProps, ResponsiveGameCollection {
  game?: Game
}

const LiveWin: React.FC<LiveWinProps> = ({ game, col, ...props }) => {
  const { isLoaded, ref } = useComponentOnScreen({ root: null, rootMargin: '10px', threshold: 0 })

  const handleValidate = useCallback(
    (betTxn: BetDetails) => {
      return (
        (!game || game.code === betTxn.game.code) && Number(betTxn.payout.amountInUsd) > Number(betTxn.bet.amountInUsd)
      )
    },
    [game],
  )

  const fetchHistory = useCallback((): HunnyRequest<BaseResponse<Paging<BetDetails>>> => {
    return GameService.getLiveBets(game?.code, LiveBetTypeEnum.LatestWin)
  }, [game])

  return (
    <Column {...props} ref={ref}>
      {isLoaded && <LiveWinStream col={col} fetchFn={fetchHistory} validateBet={handleValidate} />}
    </Column>
  )
}

export default LiveWin
